import {useEffect, useRef, useState} from "react";
import {not} from "ramda/es"
import {debounce} from "lodash";

import {
    globalHotkeysLockId,
    lockHotkeys,
    unlockHotkeys,
    // @ts-ignore
} from "@cirrus-delivery/v1/_redux/exam/shared/services/hotkeysLock.es6"

import {SearchState} from "./state";
import {IPdfSearchProps} from "./props";

export const useSearch = (props: IPdfSearchProps) => {

    const {viewerApiRef, isAnswerLocked} = props
    const searchRef = useRef<any>(null)
    const [state, setState] = useState(new SearchState())

    const debounceFocus = debounce(() => searchRef.current?.focus(), 300)
    const debounceSearch = debounce((query) => viewerApiRef.current?.find(query), 300)

    const handleSearch = (e, value) => {
        setState((prev) => ({...prev, query: value}))
        debounceSearch(value)
    }

    const onPrevMatch = () => viewerApiRef.current?.findAgain(state.query, false)
    const onNextMatch = () => viewerApiRef.current?.findAgain(state.query, true)

    const toggleSearch = (isOpened) => {
        setState((prev) => ({...prev, isOpened}))
        if (isOpened) debounceFocus()
    }

    const handleBlur = () => {
        if (not(state.query)) toggleSearch(false)
        if (not(isAnswerLocked)) unlockHotkeys(globalHotkeysLockId)
    }

    const handleWindowKeyUp = (e) => {
        const keyCode = e.which || e.keyCode

        if (keyCode == 70 && e.ctrlKey) {
            e.preventDefault()
            toggleSearch(true)
            e.stopImmediatePropagation()
        }
    }

    useEffect(() => {
        window.addEventListener("keyup", handleWindowKeyUp, true)
        return () => {
            window.removeEventListener("keyup", handleWindowKeyUp, true)
        }
    }, [])

    return {
        state,
        searchRef,
        handleSearch,
        onPrevMatch,
        onNextMatch,
        toggleSearch,
        handleBlur,
    }
}